import React from "react";
import styled from "styled-components";
import CountUp from "react-countup";
import WhyChooseUs from "./WhyChooseUs";

const WhoAreWeSection = styled.section`
  padding: 4rem 1.5rem;
  background: linear-gradient(to bottom, #ffffff, #f9fafb);

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;

    @media (min-width: 768px) {
      flex-direction: row;
      text-align: left;
      justify-content: space-between;
    }

    .text {
      flex: 1;

      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        color: #333333;
        margin-bottom: 1rem;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      p {
        font-size: 1.125rem;
        line-height: 1.8;
        color: #4b5563;
        margin-bottom: 1.5rem;
      }
    }

    .image {
      flex: 1;
      text-align: center;

      img {
        width: 100%;
        max-width: 450px;
        border-radius: 0.75rem;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        transform: scale(1);
        transition: transform 0.4s ease, box-shadow 0.4s ease;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
`;

const StatsSection = styled.section`
  padding: 4rem 1.5rem;
  background: linear-gradient(
    to bottom,
    rgb(179, 206, 234),
    rgba(255, 255, 255, 1)
  );

  .stats {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
    max-width: 900px;
    margin: 0 auto;

    @media (min-width: 768px) {
      grid-template-columns: repeat(4, 1fr);
    }

    .stat {
      background: #ffffff;
      padding: 1.5rem;
      border-radius: 0.5rem;
      border-top: 4px solid #4169e1;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      }

      .stat h3 {
        font-size: 2rem;
        font-weight: bold;
        color: #ff5757;
        margin-bottom: 0.5rem;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.1);
        }
      }
      p {
        font-size: 1rem;
        color: #6b7280;
      }
    }
  }
`;

const ReadMoreButton = styled.button`
  display: inline-block;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  background-color: #4169e1;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;

  &:hover {
    background-color: #e04545;
    transform: translateY(-3px);
  }

  &:active {
    transform: translateY(1px);
    background-color: #c53030;
  }
`;

const WhoAreWe = () => {
  const stats = [
    { count: 6, suffix: "+", label: "Years of Excellence" },
    { count: 5700, suffix: "+", label: "Successful Study Abroad Placements" },
    { count: 1000, suffix: "+", label: "Empowered Career Mentees" },
    { count: 250, suffix: "+", label: "Universities Placed" },
  ];
  const handleReadMore = () => {
    window.location.href = "/about";
  };

  return (
    <>
      <WhoAreWeSection>
        <div className="content">
          <div className="text">
            <h2>Who Are We?</h2>
            <p>
              Pristine Academic Consultancy is your trusted partner in academic
              success and career advancement, providing expert support in
              scholarly writing, mentorship, and access to study, research, and
              work opportunities abroad.
            </p>
            <ReadMoreButton onClick={handleReadMore}>Read More</ReadMoreButton>
          </div>
          <div className="image">
            <img src="/images/img77.jpg" alt="Our Team" />
          </div>
        </div>
      </WhoAreWeSection>
      <WhyChooseUs />

      {/* <StatsSection>
        <div className="stats">
          {stats.map((stat, index) => (
            <div className="stat" key={index}>
              <h3>
                <CountUp
                  start={0} // Start from 0
                  end={stat.count} // End value
                  suffix={stat.suffix} // Add the suffix
                  duration={3.0} // Duration of animation (in seconds)
                  delay={0.5} // Delay before animation starts (in seconds)
                  separator="," // Adds commas for large numbers
                  easingFn={(t, b, c, d) => -c * (t /= d) * (t - 2) + b} // Easing effect
                />
              </h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </StatsSection> */}
    </>
  );
};

export default WhoAreWe;
